import CostaRicaBank from "./CostaRicaBank";
import EditBankAccount from "./EditBankAccount";
import PanamaBank from "./PanamaBank";
import { WithdrawalDetails } from "../../../types";
import CardText from "../../CardText";
import TransactionCard from "../../TransactionCard";

type Props = {
  bank: WithdrawalDetails["bank"];
  onEditBankPress: () => void;
};

export default function BankCard({ bank, onEditBankPress }: Props) {
  const { country, errorMessage } = bank;

  const renderBank = () => {
    switch (country) {
      case "pty":
        return <PanamaBank bank={bank[country]} />;
      case "cr":
        return <CostaRicaBank bank={bank[country]} />;
      default:
        return null;
    }
  };

  return (
    <TransactionCard>
      <CardText.Title text="Cuenta" />
      {renderBank()}
      {errorMessage && (
        <EditBankAccount
          errorMessage={errorMessage}
          onEditPress={onEditBankPress}
        />
      )}
    </TransactionCard>
  );
}
